import React from 'react';
import PropTypes from 'prop-types';
import SideModal from '../../../components/modals/SideModal';
import StrategyTable from '../StrategyTable/StrategyTable';
import { useOracleRequestDetail } from '../../hooks/useOracleRequestDetail';
import styles from './RequestDetailsModal.module.css';

const RequestDetailsModal = ({ isOpen, onClose, requestId, country }) => {
    const { data, loading, error } = useOracleRequestDetail({
        country,
        requestId: isOpen ? requestId : null
    });

    const renderHeader = () => (
        <div className={styles.modalHeader}>
            <div className={styles.headerTitleContainer}>
                <h3 className={styles.modalTitle}>Detalle de Solicitud</h3>
                {requestId && (
                    <span className={styles.requestId}>ID: {requestId}</span>
                )}
            </div>
            <button
                className={styles.closeButton}
                onClick={onClose}
                aria-label="Cerrar"
            >
                <span aria-hidden="true" className={styles.closeIcon}>&times;</span>
            </button>
        </div>
    );

    const renderFooter = () => null;

    const renderContent = () => {
        if (loading) {
            return (
                <div className={styles.loadingContainer}>
                    Cargando detalles...
                </div>
            );
        }

        if (error) {
            return (
                <div className={styles.contentContainer}>
                    <div className={styles.errorContainer}>
                        Error al cargar los detalles. Por favor, intenta nuevamente.
                    </div>
                </div>
            );
        }

        if (!data) {
            return null;
        }

        return (
            <div className={styles.contentContainer}>
                <div className={styles.metadataRow}>
                    <div className={styles.metadataItem}>
                        <span className={styles.metadataLabel}>País</span>
                        <span className={styles.metadataValue}>{data.country?.toUpperCase()}</span>
                    </div>
                </div>

                {data.error_reason && (
                    <div className={styles.errorReasonAlert}>
                        <div className={styles.errorReasonIcon}>
                            🚨
                        </div>
                        <div className={styles.errorReasonText}>
                            <span className={styles.errorReasonLabel}>Error:</span>
                            {data.error_reason}
                        </div>
                    </div>
                )}

                <StrategyTable
                    strategies={data.strategies}
                    loading={false}
                    defaultShowEmpty={false}
                />
            </div>
        );
    };

    return (
        <SideModal
            active={isOpen}
            onClose={onClose}
            renderHeader={renderHeader}
            renderFooter={renderFooter}
        >
            {renderContent()}
        </SideModal>
    );
};

RequestDetailsModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    requestId: PropTypes.string,
    country: PropTypes.string.isRequired
};

RequestDetailsModal.defaultProps = {
    requestId: null
};

export default RequestDetailsModal;
